import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom'
import ReactPlayer from 'react-player/youtube'
import Style from './meal.module.css'

class Meal extends React.Component{
    constructor(props){
        super(props)
        // console.log(props.match)
        this.state = {
            mealID: props.match.params.mealID,
            mealInfo: []
        }
    }
    componentDidMount(){
        axios.get('https://www.themealdb.com/api/json/v1/1/lookup.php?',{
            params:{
                i: this.state.mealID
            }
        })
        .then(res => this.setState({
                mealInfo: res.data.meals
            })
        )
    }
    render(){
        return(
            <div>
                {
                    this.state.mealInfo && this.state.mealInfo.map(item => (
                        <div key={item.idMeal}>
                            <h1 id={Style.meal} className="my-5 text-center">{item.strMeal}</h1>
                            <div className="row">
                                <div className="col-12 col-lg-5 mb-5 mb-lg-0 text-center">
                                    <img width="540px" className="img-fluid rounded-lg" src={item.strMealThumb} alt=""/>
                                </div>
                                <div className="col-12 col-lg-7 text-center text-lg-left" style={{fontSize: "21px"}}>
                                    <div className="mb-3">
                                        <span id={Style.meal}>Category: </span>
                                        <span><Link className="text-dark" to={`/categories/${item.strCategory}`}>{item.strCategory !== "" ? item.strCategory : "-"}</Link></span>
                                    </div>
                                    <div className="mb-3">
                                        <span id={Style.meal}>Region: </span>
                                        <span><Link className="text-dark" to={`/region/${item.strArea}`}>{item.strArea !== "" ? item.strArea : "-"}</Link></span>
                                    </div>
                                    <div className="mb-3">
                                        <span id={Style.meal}>Tags: </span>
                                        <span>{item.strTags !== "" ? item.strTags : "-"}</span>
                                    </div>
                                    <div className="mb-5">
                                        <span id={Style.meal}>Source: </span>
                                        <span><a className="text-primary" href={item.strSource}>Link</a></span>
                                    </div>
                                    <div className="mb-3">
                                        <span id={Style.meal}>Ingredients: </span>
                                        <div className="row">
                                            <div className="col-12 col-xl-6">
                                                <div className="ml-0  ml-lg-5 ml-xl-5">{item.strIngredient1 !== "" ? "1. " + item.strIngredient1 + " - " : ""}{item.strMeasure1 !== "" ? item.strMeasure1 : ""}</div>
                                                <div className="ml-0  ml-lg-5 ml-xl-5">{item.strIngredient2 !== "" ? "2. " + item.strIngredient2 + " - " : ""}{item.strMeasure2 !== "" ? item.strMeasure2 : ""}</div>
                                                <div className="ml-0  ml-lg-5 ml-xl-5">{item.strIngredient3 !== "" ? "3. " + item.strIngredient3 + " - " : ""}{item.strMeasure3 !== "" ? item.strMeasure3 : ""}</div>
                                                <div className="ml-0  ml-lg-5 ml-xl-5">{item.strIngredient4 !== "" ? "4. " + item.strIngredient4 + " - " : ""}{item.strMeasure4 !== "" ? item.strMeasure4 : ""}</div>
                                                <div className="ml-0  ml-lg-5 ml-xl-5">{item.strIngredient5 !== "" ? "5. " + item.strIngredient5 + " - " : ""}{item.strMeasure5 !== "" ? item.strMeasure5 : ""}</div>
                                                <div className="ml-0  ml-lg-5 ml-xl-5">{item.strIngredient6 !== "" ? "6. " + item.strIngredient6 + " - " : ""}{item.strMeasure6 !== "" ? item.strMeasure6 : ""}</div>
                                                <div className="ml-0  ml-lg-5 ml-xl-5">{item.strIngredient7 !== "" ? "7. " + item.strIngredient7 + " - " : ""}{item.strMeasure7 !== "" ? item.strMeasure7 : ""}</div>
                                                <div className="ml-0  ml-lg-5 ml-xl-5">{item.strIngredient8 !== "" ? "8. " + item.strIngredient8 + " - " : ""}{item.strMeasure8 !== "" ? item.strMeasure8 : ""}</div>
                                                <div className="ml-0  ml-lg-5 ml-xl-5">{item.strIngredient9 !== "" ? "9. " + item.strIngredient9 + " - " : ""}{item.strMeasure9 !== "" ? item.strMeasure9 : ""}</div>
                                                <div className="ml-0  ml-lg-5 ml-xl-5">{item.strIngredient10 !== "" ? "10. " + item.strIngredient10 + " - " : ""}{item.strMeasure10 !== "" ? item.strMeasure10 : ""}</div>
                                            </div>
                                            <div className="col-12 col-xl-6">
                                                <div className="ml-0  ml-lg-5 ml-xl-0">{item.strIngredient11 !== "" ? "11. " + item.strIngredient11 + " - " : ""}{item.strMeasure11 !== "" ? item.strMeasure11 : ""}</div>
                                                <div className="ml-0  ml-lg-5 ml-xl-0">{item.strIngredient12 !== "" ? "12. " + item.strIngredient12 + " - " : ""}{item.strMeasure12 !== "" ? item.strMeasure12 : ""}</div>
                                                <div className="ml-0  ml-lg-5 ml-xl-0">{item.strIngredient13 !== "" ? "13. " + item.strIngredient13 + " - " : ""}{item.strMeasure13 !== "" ? item.strMeasure13 : ""}</div>
                                                <div className="ml-0  ml-lg-5 ml-xl-0">{item.strIngredient14 !== "" ? "14. " + item.strIngredient14 + " - " : ""}{item.strMeasure14 !== "" ? item.strMeasure14 : ""}</div>
                                                <div className="ml-0  ml-lg-5 ml-xl-0">{item.strIngredient15 !== "" ? "15. " + item.strIngredient15 + " - " : ""}{item.strMeasure15 !== "" ? item.strMeasure15 : ""}</div>
                                                <div className="ml-0  ml-lg-5 ml-xl-0">{item.strIngredient16 !== "" ? "16. " + item.strIngredient16 + " - " : ""}{item.strMeasure16 !== "" ? item.strMeasure16 : ""}</div>
                                                <div className="ml-0  ml-lg-5 ml-xl-0">{item.strIngredient17 !== "" ? "17. " + item.strIngredient17 + " - " : ""}{item.strMeasure17 !== "" ? item.strMeasure17 : ""}</div>
                                                <div className="ml-0  ml-lg-5 ml-xl-0">{item.strIngredient18 !== "" ? "18. " + item.strIngredient18 + " - " : ""}{item.strMeasure18 !== "" ? item.strMeasure18 : ""}</div>
                                                <div className="ml-0  ml-lg-5 ml-xl-0">{item.strIngredient19 !== "" ? "19. " + item.strIngredient19 + " - " : ""}{item.strMeasure19 !== "" ? item.strMeasure19 : ""}</div>
                                                <div className="ml-0  ml-lg-5 ml-xl-0">{item.strIngredient20 !== "" ? "20. " + item.strIngredient20 + " - " : ""}{item.strMeasure20 !== "" ? item.strMeasure20 : ""}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <h1 id={Style.meal} className="mt-5 text-center">Instructions</h1>
                                    <div className="card border-0 mx-auto" style={{width: "80%", backgroundColor: "#f8e2d5"}}>
                                        <div className="card-body" style={{fontSize: "22px", textAlign: "justify"}}>
                                            {item.strInstructions}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mb-5">
                                <div className="col">
                                    <h1 id={Style.meal} className="mt-5 mb-4 text-center">Video</h1>
                                    <div>
                                        <ReactPlayer className="mx-auto" url={item.strYoutube} controls={true} pip={true} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
        )
    }
}

export default Meal